<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/products'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :defaultPayload="updateDefaultPayload"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
// import { ProductService } from "../../../_services/api/products/product.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Product Attribute 18",
        pageRoute: "/product-attribute-18",
        saveEndPoint: "ProductAttribute18",
        updateEndPoint: "ProductAttribute18",
        recordEndPoint: "ProductAttribute18",
        isDefaultEndPoint: "ProductAttribute18/SaveDefault",
        exportFileName: "Bin Location Type",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductAttribute18",
              filter: "",
              select: [
                "Code",
                "Description",
                "Inactive",
                "IsDefault",
                "RecordId",
              ],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "product-attribute-18",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/product-attribute-18/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "ProductAttribute18",
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined,
                  clickedDefaultRecordId = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code) {
                      clickedDefault = element.Code;
                      clickedDefaultRecordId = element.RecordId;
                    }
                    if (element.IsDefault == "Y") getDefault = element.Code;
                  });
                if (!getDefault)
                  await SplitViewService.getIsDefault(
                    "ProductAttribute18"
                  ).then((res) => {
                    if (res.data.value.length > 0)
                      getDefault = res.data.value[0].Code;
                  });
                let confirmLeaving = await this.$confirm(
                  `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
                  "Default Setting Change"
                );
                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.updatedDefaultRecordId = clickedDefaultRecordId;
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
      },
      updatedDefaultRecordId: undefined,
    };
  },
  computed: {
    updateDefaultPayload() {
      return {
        RecordId: this.updatedDefaultRecordId,
      };
    },
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorOptions: {
                  maxLength: 4,
                },
                required: true,
                screenField: "Code",
                isPrimaryKeyField: true,
                label: { text: "Type" },
                visible: true,
                allowUpdate: this.baseView.mode == "create",
              },
              {
                dataField: "Description",
                label: { text: "Description" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                screenField: "Code",
                isPrimaryKeyField: true,
              },
              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        // this.setLoading = true;
        // ProductService.getProductData(
        //   `ProductAttribute18Code eq '${this.baseView.id}'`
        // )
        //   .then((res) => {
        //     this.setLoading = false;
        //     if (res.data.value.length > 0) {
        // this.formModel.Inactive = true;
        // e.component.beginUpdate();
        // e.component.option("value", true);
        // e.component.endUpdate();
        //       this.validationSummary = [];
        //       this.validationSummary.push({
        //         message: `${this.baseView.id} is associated with product records. This may not be marked inactive until it is no longer associated with product records.`,
        //       });
        //       this.validationSummary.push({
        //         message: `Tip: To identify the associated product use the filters on the product list.`,
        //       });
        //     }
        //   })
        //   .catch((err) => {
        //     if (err) this.setLoading = false;
        //   });
      }
    },
  },
};
</script>
